import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'
import { useTranslation } from 'react-i18next'

interface ConfirmationProps {
  show: boolean
  onClose: () => void
  onAccept: () => void
}

export const Confirmation = ({
  show,
  onClose,
  onAccept,
}: ConfirmationProps) => {
  const { t } = useTranslation()
  return (
    <ConfirmationModal
      show={show}
      text={t('administration.blocks.hasResponsesButCanModify')}
      acceptButtonText={t('components.modal.buttons.accept')}
      onAccept={onAccept}
      onClose={onClose}
    />
  )
}
